const baseUrl = document.querySelector('base');

const environment = {
    baseUrl: baseUrl ? baseUrl.value : '/'
};

export default environment;
